import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Cookie from 'js-cookie';
import qs from 'qs';
import { message, } from 'antd';
import { ClockCircleOutlined, TeamOutlined, HistoryOutlined } from "@ant-design/icons";
import {
  Element,
  Events,
  animateScroll as scroll,
  scroller,
} from "react-scroll";
import { getAllTypes, getLoginUserInfo } from '../../College/apis/course';
import Ban_img from "../../assets/images/ban_img.svg";
import { getBannerList, getQxProfile, getQxToken } from '../../apis/public';
import { getNoCourseList, getNoActivityList, getNoExamList } from "../../College/apis/public";
import { getCourseList } from '../../College/apis/course';
import { getInternalExamList } from '../../College/apis/exam';
import { getActivityList } from '../../College/apis/activity';
import moment from 'moment';
import MenuComp from '../../College/layout/Menu';
import { judgeIsLogin, judgeLogin } from "../../common/utils";
import { isQx, appid } from "../../common/variable";
import { redirectUrl } from '../../service/request'
import './index.less';

// const mainMenu: any[] = [
//   // {
//   //   key: 'home',
//   //   name: '首页',
//   //   path: '/college'
//   // },
//   {
//     key: 'course',
//     name: '课程中心',
//     path: '/college/menu/main/course'
//   },
//   {
//     key: 'exam',
//     name: '考试中心',
//     path: '/college/menu/main/exam'
//   },
//   {
//     key: 'train',
//     name: '活动中心',
//     path: '/college/menu/main/activity'
//   }
// ]

interface IProps extends RouteComponentProps { };
interface IState {
  typesData: any[];
  bannerData: any[];
  courseData: any[];
  examData: any[];
  activityData: any[];
};

class HomePage extends Component<IProps, IState> {
  scrollElement: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      typesData: [],
      bannerData: [],
      courseData: [],
      examData: [],
      activityData: []
    }

  }
  componentDidMount() {
    // const _url = window.location.href;
    const partnerToken = Cookie.get('TOKEN:PARTNER:qingcloud');
    console.log('cookie', partnerToken);
    if (partnerToken) {
      // if (_url.indexOf("?code") >= 0) {
      //   this.getUserToken();
      // }
      localStorage.setItem('token', JSON.stringify(partnerToken));
      getQxProfile({}).then((res: any) => {
        console.log(res);
        if (res.code === 0) {
          const { isAdmin, realName, userId, employeeEmail } = res.data;
          const data = {
            id: userId,
            employee_name: realName,
            crm_account_name: realName,
            employee_email: employeeEmail || '',
            is_admin: isAdmin
          };
          localStorage.setItem('userinfo', JSON.stringify(data));
        } else {
          localStorage.clear();
          Cookie.remove('TOKEN:PARTNER:qingcloud', { path: '', domain: '.quanxiangyun.com' });
        }
      })
    }
    // else {
    //   // if (_url.indexOf("user_id") >= 0 && _url.indexOf("token") >= 0) {
    //   //   let userid = _url.split("?user_id=")[1];
    //   //   const token = userid.split("&token=")[1].split("#/")[0];
    //   //   userid = userid.split("&token=")[0];
    //   //   localStorage.setItem('userId', JSON.stringify(userid));
    //   //   localStorage.setItem('token', JSON.stringify(token));
    //   //   getLoginUserInfo({ user_id: userid, id: userid }).then((res: any) => {
    //   //     if (res && res.code === 0) {
    //   //       localStorage.setItem('userinfo', JSON.stringify(res.data));
    //   //     }
    //   //   })
    //   // }
    //   const test = window.location.href;
    //   if (test.indexOf("user_id") < 0) {
    //     window.location.href = redirectUrl;
    //   }
    //   let userid = test.split("?user_id=")[1];
    //   if (userid) {
    //     const token = userid.split("&token=")[1].split("#/")[0];
    //     userid = userid.split("&token=")[0];
    //     localStorage.setItem('userId', JSON.stringify(userid)); //
    //     localStorage.setItem('token', JSON.stringify(token));
    //     // this.getUserInfo(userid);
    //     getLoginUserInfo({ user_id: userid, id: userid }).then((res: any) => {
    //       if (res && res.code === 0) {
    //         localStorage.setItem('userinfo', JSON.stringify(res.data));
    //       }
    //     })
    //   } else {
    //     window.location.href = redirectUrl;
    //   }
    // }
    this.scrollElement = window.addEventListener('scroll', this.handleScroll);
    this.judgeUserLogin();
  }
  // 判断用户是否登陆
  judgeUserLogin = () => {
    let _bol = localStorage.getItem('token') ? true : false;
    if (_bol) {
      this.getCourse();
      this.getExam();
      this.getActivity();
    } else {
      this.getNoCourse();
      this.getNoExam();
      this.getNoActivity();
    }
  }
  // 获取课程 - 未登录时
  getNoCourse = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getNoCourseList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          courseData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取课程 - 登陆后
  getCourse = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getCourseList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          courseData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取考试 - 未登录
  getNoExam = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getNoExamList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          examData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取考试 - 登陆后
  getExam = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getInternalExamList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          examData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取活动 - 未登录
  getNoActivity = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getNoActivityList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          activityData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取活动 - 登陆后
  getActivity = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getActivityList(params).then((res: any) => {
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          activityData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 根据code值获取token
  getUserToken = () => {
    let _code = '';
    const { search, href } = window.location;
    if (search) {
      console.log('search', search);
      let str = search.substr(1);
      let params = qs.parse(str);
      console.log(params);
      _code = params.code || "";
    } else {
      const arr = href.split('code=');
      console.log(arr);
      _code = arr[1].substring(0, arr[1].length - 2);
    }
    getQxToken({ code: _code }).then((res: any) => {
      if (res && res.code === 0) {
        const { profile = {}, token } = res.data;
        const { userId, realName, email, isAdmin } = profile;
        localStorage.setItem('userId', JSON.stringify(userId));
        localStorage.setItem('token', JSON.stringify(token));
        const data = {
          ...profile,
          id: profile.userId,
          employee_name: realName,
          crm_account_name: realName,
          employee_email: email,
          is_admin: isAdmin
        };
        localStorage.setItem('userinfo', JSON.stringify(data));
        // window.location.href = window.location.origin + '/qingcloud/learning';
        window.location.href = window.location.origin;
      } else {
        res && message.error(res.msg);
      }
    })
  }

  handleScroll = (e: any) => {
    const _height = document.documentElement.scrollTop;
    const _ele: any = document.getElementById('qy_nav');
    if (!_ele) {
      return
    }
    const _bol = document.getElementById('qy_nav')?.classList.contains('qy_nav_fixed');
    if (_height > 0 && !_bol) {
      _ele.classList.add('qy_nav_fixed');
    }
    if (_bol && _height === 0) {
      _ele.classList.remove('qy_nav_fixed');
    }
  }
  // 获取轮播
  getBanner = () => {
    const params = {
      page: 1,
      limit: 10
    }
    getBannerList(params).then((res: any) => {
      console.log(res);
      if (res && res.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          bannerData: data ? data : []
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取公共页面展示课程 - 分类加课程
  getPublicCourse = () => {
    const params = {
      page: 1,
      limit: 6
    }
    getCourseList(params).then((res: any) => {
      console.log(res);
      if (res && res.code === 0) {
        const types: any[] = [];
        const { data = [] } = res;
        const _data = data ? data : [];
        _data.map((item: any) => types.push({ id: item.id, type_name: item.type_name }));
        this.setState({
          typesData: types,
          courseData: _data
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 获取所有分类
  getTypes = () => {
    let params = {
      menu_name: '课程中心' // 菜单名称
    };
    getAllTypes(params).then((res: any) => {
      console.log(res);
      if (res && res.code === 0) {
        const { types } = res.data;
        this.setState({
          typesData: types
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
    if (this.scrollElement) {
      this.scrollElement.remove();
    }
  }
  //
  scroleHandle = (name: string) => {
    console.log(name);
    scroller.scrollTo(name, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      // containerId: "container",
      offset: -80, // 偏移量
    })
  }
  // 滚动到顶部
  scrollToTop = () => {
    scroll.scrollToTop();
  }
  // 上一页
  handlePrev = () => {
    // this.refs.swipers.prev(); // 此方法会报错
    let _handle: any = this.refs.swipers;
    _handle.prev();
  }
  // 下一页
  handleNext = () => {
    // this.refs.swipers.prev(); // 此方法会报错
    let _handle: any = this.refs.swipers;
    _handle.next();
  };
  // 立即学习
  startStudy(id: string) {
    if (judgeLogin()) {
      this.props.history.push(`/college/menu/main/course/detail/${id}`);
    }
  }
  // 轮播图-查看详情
  goDetail(data: any) {
    if (data.type_id) { // 如果是分类id就跳转课程中心
      this.props.history.push(`/college/menu/main/course/${data.type_id}`)
    } else { // 是录入的课程就跳转课程详情
      this.props.history.push(`/college/menu/main/course/detail/${data.curriculum_id}`)
    }
  }
  // 点击分类
  clickType = (data: any) => {
    this.props.history.push(`/college/menu/main/course/${data.id}`);
  }
  // 切换菜单
  changeMenu = (menu: any) => {
    if (judgeIsLogin()) {
      this.props.history.push(menu.path);
    }
    // window.localStorage.setItem('collegeMenu', menu.path);
  }
  // 课程-更多
  goCourseMore = (data: any) => {
    this.props.history.push(`/college/menu/main/course`);
  }
  // 考试
  goExamMore = () => {
    this.props.history.push('/college/menu/main/exam');
  }
  goExamInfo = (exam: any) => {
    this.props.history.push(`/college/menu/main/exam/${exam.id}/${exam.attribute}`);
  }
  // 活动
  goActivityMore = () => {
    this.props.history.push('/college/menu/main/activity');
  }
  goActivityInfo = (activity: any) => {
    this.props.history.push(`/college/menu/main/activity/${activity.id}`);
  }
  // 登陆或注册
  goLogin = () => {
    judgeIsLogin();
    // window.location.href = redirectUrl;
  }
  // goRegister = () => {
  // 查看全部课程
  searchAllCourses = () => {
    this.props.history.push("/college/menu/main/course");
  }
  // }
  // 退出登陆
  signoutHandle = () => {
    localStorage.clear();
  }

  render() {
    const { examData, courseData, activityData } = this.state;
    // const signOut = <span style={{color: '#000', cursor: 'pointer'}} onClick={this.signoutHandle}>退出登录</span>;
    // const _info: any = userinfo.id ? getUserImg(userinfo.crm_account_name) : {};
    const userinfo = window.localStorage.getItem('userinfo') ? JSON.parse(window.localStorage.getItem('userinfo') || JSON.stringify(null)) : {};
    return (
      <div id="qy_home" className="qy_home">
        <div className="qy_sider">
          <div className="sider_li" onClick={this.scroleHandle.bind(this, 'course_list')}>课程<br />列表</div>
          {
            examData.length > 0 &&
            <div className="sider_li" onClick={this.scroleHandle.bind(this, 'exam_list')}>考试<br />列表</div>
          }
          {
            activityData.length > 0 &&
            <div className="sider_li" onClick={this.scroleHandle.bind(this, 'activity_list')}>活动<br />列表</div>
          }
          <div className="sider_li" onClick={this.scrollToTop}>回到<br />顶部</div>
        </div>
        <div className="qy_nav" id="qy_nav">
          <div className="menv" style={{ backgroundColor: '#000' }}>
            <MenuComp userinfo={userinfo} />
          </div>
          {/* <div className="nav_in">
            <div className="nav_in_left">
              <div className="img">
                <img src={Logo} alt="青云学院"/>
              </div>
              <ul className="menu">
                {
                  mainMenu.map(menu => <li key={menu.key} onClick={this.changeMenu.bind(this, menu)}>{menu.name}</li>)
                }
              </ul>
            </div>
            <div className="nav_in_right">
              <div></div>
              <div className="right_search">
                <input placeholder="搜索感兴趣的课程" />
                <div className="btn"><span className="iconfont icon-sousuo"></span></div>
              </div>
              <div className="right_act">
              {
                userinfo.id ? 
                <Tooltip  title={signOut} color='#FFF'>
                <div className="img" style={{background: `${_info.color}`}}>{_info.name}</div>
              </Tooltip>
              : <>
              <span onClick={this.goLogin}>登陆</span>
              </>
              }
                ｜
                <span onClick={this.goRegister}>注册</span>
              </div>
            </div>
          </div> */}
        </div>
        <div className="qy_ban">
          <div className="qy_ban_cent">
            <div className="ban_in">
              <div className="title">合作伙伴支持平台</div>
              <div className="tip">利用青云QingCloud丰富的培训资源助力合作伙伴掌握云计算知识，提升专业技能。</div>
              <div className="btn" onClick={this.searchAllCourses}>查看全部课程</div>
            </div>
            <img src={Ban_img} className="img" alt="" />
          </div>
        </div>
        {/* <Element id="container" className="container"> */}
        <div className="qy_cont">
          <div className="qy_cont_tainer">
            <Element name="course_list">
              {/* 课程列表 */}
              <div className="qy_courses">
                <div className="course_title">
                  <div className="course_title_left">
                    <p>课程列表</p>
                    <div className="yin"></div>
                  </div>
                  <span style={{ cursor: 'pointer' }} onClick={this.goCourseMore}>查看更多...</span>
                </div>
                <ul>
                  {
                    courseData && courseData.map(course => {
                      return (
                        <li key={course.id} onClick={() => this.startStudy(course.id)}>
                          <div className="course_item">
                            <img src={course.file_url} alt="" />
                            <div className="text">
                              <div className="title">{course.curriculum_name}</div>
                              <div className="line"></div>
                              <div className="cour">
                                <div className="left"> <TeamOutlined /> {course.total_see}</div>
                                <div className="right"> <HistoryOutlined /> {moment(course.create_time * 1000).format("YYYY-MM-DD")}</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
              {/* {
                courseData && courseData.map(item => {
                  return (
                    <div className="qy_courses" key={item.id}>
                      <div className="course_title">
                        <div className="course_title_left">
                          <p>课程列表</p>
                          <div className="yin"></div>
                        </div>
                        <span style={{cursor: 'pointer'}} onClick={this.goCourseMore.bind(this, item)}>查看更多...</span>
                      </div>
                      <ul>
                        {
                          item.curriculums && item.curriculums.map((course: any) => {
                            return (
                              <li key={course.id} onClick={() => this.startStudy(course.id)}>
                                <div className="course_item">
                                  <img src={course.file_url} alt=""/>
                                  <div className="text">
                                    <div className="title">{course.curriculum_name}</div>
                                    <div className="line"></div>
                                    <div className="cour">
                                      <div className="left"> <TeamOutlined /> {course.total_see}</div>
                                      <div className="right"> <HistoryOutlined /> {moment(course.create_time * 1000).format("YYYY-MM-DD")}</div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  )
                })
              } */}
            </Element>
            {/* 考试列表 */}
            {
              examData.length > 0 &&
              <Element name="exam_list">
                <div className="qy_courses">
                  <div className="course_title">
                    <div className="course_title_left">
                      <p>考试列表</p>
                      <div className="yin"></div>
                    </div>
                    <span style={{ cursor: 'pointer' }} onClick={this.goExamMore}>查看更多...</span>
                  </div>
                  <ul>
                    {
                      examData && examData.map(item => {
                        return (
                          <li key={item.id} onClick={() => this.goExamInfo(item)}>
                            <div className="course_item">
                              <img src={item.file_url} alt="" />
                              <div className="text">
                                <div className="title">{item.exam_title}</div>
                                <div className="line"></div>
                                <div className="cour">
                                  <div className="left"> <ClockCircleOutlined /> 考试时间： {moment(item.start_time * 1000).format('YYYY-MM-DD')} ～ {moment(item.end_time * 1000).format('YYYY-MM-DD')}</div>
                                  <div className="right"> </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </Element>
            }
            {/* 活动列表 */}
            {
              activityData.length > 0 &&
              <Element name="activity_list">
                <div className="qy_courses">
                  <div className="course_title">
                    <div className="course_title_left">
                      <p>活动列表</p>
                      <div className="yin"></div>
                    </div>
                    <span style={{ cursor: 'pointer' }} onClick={this.goActivityMore}>查看更多...</span>
                  </div>
                  <ul>
                    {
                      activityData && activityData.map(item => {
                        return (
                          <li key={item.id} onClick={() => this.goActivityInfo(item)}>
                            <div className="course_item">
                              <img src={item.file_url} alt="" />
                              <div className="text">
                                <div className="title">{item.title}</div>
                                <div className="line"></div>
                                <div className="cour">
                                  <div className="left" style={{ color: '#53B880' }}><ClockCircleOutlined /> 活动进行中</div>
                                  <div className="right"></div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </Element>
            }
          </div>
        </div>
        {/* <div className="qy_footer">
            <div className="qy_footer_in">
              <div className="qy_footer_in_top">
                <div className="left">
                  <img src={Footer_Logo} alt=""/>
                  <div className="left_bot">
                    <img src={Footer_Er} alt=""/>
                    <ul>
                      <li><PhoneOutlined /> 400-8576-886</li>
                      <li><MailOutlined /> 邮箱</li>
                      <li><CommentOutlined /> 微博</li>
                    </ul>
                  </div>
                </div>
                <Row className='right' align="top" gutter={32}>
                  <Col span={6}>
                    <div className="right_item">
                      <p>关于我们</p>
                      <div className="line"></div>
                      <ul>
                        <li>公司概况</li>
                        <li>企业动态</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>产品服务</p>
                      <div className="line"></div>
                      <ul>
                        <li>账号管理</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>服务支持</p>
                      <div className="line"></div>
                      <ul>
                        <li>服务状态</li>
                      </ul>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="right_item">
                      <p>合作与生态</p>
                      <div className="line"></div>
                      <ul>
                        <li>青云学院</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="footer_in_bot">
                京ICP备13019086号  京公网安备11010502024565
              </div>
            </div>
          </div> */}
        {/* </Element> */}
      </div>
    )
  }
}

export default HomePage;
